export enum EGroupExercises {
    EXERCISE_BURPEES = 'ExerciseBurpee',
    EXERCISE_JUMPINGJACKES = 'ExerciseJumpingJack',
    EXERCISE_SPRINT = 'ExerciseSprint',
    EXERCISE_PUNCH = 'ExercisePunch',
    EXERCISE_TRACKER_CHECK = 'ExerciseTrackerCheck',
    EXERCISE_TIMER = 'ExerciseTimer',
    EXERCISE_CUES = 'ExerciseCues',
    EXERCISE_JUMPROPE = 'ExerciseJumpRope',
    EXERCISE_GENERIC_TRANSITION = 'ExerciseGenericTransition',
    EXERCISE_SQUATS = 'ExerciseSquat',
    EXERCISE_SHOULDERTOUCHES = 'ExerciseShoulderTouch',
    EXERCISE_PREVIOUS_EXERCISE_SUMMARY = 'ExercisePreviousExerciseSummary',
    EXERCISE_ACTIVITY_SUMMARY = 'ExerciseActivitySummary',
    EXERCISE_LAST_MAN_STANDING = 'ExerciseLastManStanding',
    EXERCISE_LAST_TWO_EXERCISE_SUMMARY = 'ExerciseLastTwoExerciseSummary',
    EXERCISE_CALORIES_BURNED = 'ExerciseCaloriesBurned',
    EXERCISE_BR_JUMPING_JACKS = 'ExerciseBRJumpingJack',
    EXERCISE_BR_JUMP_SLAM = 'ExerciseBRJumpSlam',
    EXERCISE_BR_PUSH_UPS = 'ExerciseBRPushUps',
    EXERCISE_BR_SQUAT_PRESS = 'ExerciseBRSquatPress',
    EXERCISE_BR_STRAIGHT_ARMS = 'ExerciseBRStraightArms',
    EXERCISE_BR_WAVES = 'ExerciseBRWaves',
    EXERCISE_RACE = 'ExerciseRace',
    EXERCISE_TRASH_TALK = 'ExerciseTrashTalk',
    EXERCISE_BALL_CORE = 'ExerciseBallCore',
    EXERCISE_SQUAT_SWING = 'ExerciseSquatSwing',
    EXERCISE_MB_SLAM = 'ExerciseMbSlam',
    EXERCISE_PUNCH_POWER = 'ExercisePunchPower',
    EXERCISE_PUNCH_INTENSITY = 'ExercisePunchIntensity',
    EXERCISE_PUNCH_SPEED = 'ExercisePunchSpeed',
    EXERCISE_PAIR_DISPLAY = 'ExercisePairDisplay',
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/config/EGroupExercises.ts